module.exports = __webpack_public_path__ + "static/media/landing-tab-provider-search-d.8c364493.svg";